import { render, staticRenderFns } from "./content-type-2.vue?vue&type=template&id=dce03bf6&scoped=true&"
import script from "./content-type-2.vue?vue&type=script&lang=js&"
export * from "./content-type-2.vue?vue&type=script&lang=js&"
import style0 from "./content-type-2.vue?vue&type=style&index=0&id=dce03bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce03bf6",
  null
  
)

export default component.exports